export var AuthStrategyType = /*#__PURE__*/function (AuthStrategyType) {
  AuthStrategyType["authenticate"] = "authenticate";
  AuthStrategyType["register"] = "register";
  return AuthStrategyType;
}(AuthStrategyType || {});